import {
  IconFilePencil,
  IconScan,
  IconPoint,
  IconChartDots,
  IconUser,
  IconKey,
  IconDiscount2,
  IconChartPie,
  IconTicket,
  IconPrinter,
  IconGoGame,
  IconPhotoAi,
  IconTrophy,
  IconCalendarClock,
  IconToggleLeft,
  IconHeartHandshake,
} from '@tabler/icons-react';

import { uniqueId } from 'lodash';
const eventId = JSON.parse(localStorage.getItem('eventId'));

const Menuitems = [
  {
    id: uniqueId(),
    title: 'Tổng quan',
    titleI18n: 'MENU:dashboard',
    icon: IconChartPie,
    href: '/',
  },
  {
    navlabel: true,
    subheader: 'Quản lý',
    subheaderI18n: 'MENU:management',
  },
  {
    id: uniqueId(),
    title: 'Đơn đăng ký',
    titleI18n: 'MENU:order',
    icon: IconFilePencil,
    href: '/info-event-payment',
  },
  {
    id: uniqueId(),
    title: 'Đơn hàng vé số',
    titleI18n: 'MENU:order_ticket',
    icon: IconFilePencil,
    href: '/event-payment-ticket',
  },
  {
    id: uniqueId(),
    title: 'Khách đăng ký',
    titleI18n: 'MENU:user_invite',
    icon: IconUser,
    href: '/user-invite',
  },
  {
    id: uniqueId(),
    title: 'Check in',
    titleI18n: 'MENU:checkinout',
    icon: IconScan,
    href: '/checkin-out/diem-danh',
    isEqual: true,
  },
  {
    id: uniqueId(),
    title: 'Thư viện ảnh',
    titleI18n: 'MENU:gallery_title',
    icon: IconPhotoAi,
    href: '/gallery',
  },
  {
    id: uniqueId(),
    title: 'Thống kê',
    titleI18n: 'MENU:statistics',
    icon: IconChartDots,
    href: '/checkinout',
    children: [
      {
        id: uniqueId(),
        title: 'Khách tham dự',
        titleI18n: 'MENU:customers',
        icon: IconPoint,
        href: '/checkin-out',
        isEqual: true,
      },
      {
        id: uniqueId(),
        title: 'Lịch sử gửi mail',
        titleI18n: 'MENU:send_mail_history',
        icon: IconPoint,
        href: '/send-mail-history',
      },
      {
        id: uniqueId(),
        title: 'Trúng thưởng',
        titleI18n: 'MENU:table-winner',
        icon: IconPoint,
        href: '/lucky-draw',
      },
    ],
  },
  {
    navlabel: true,
    subheader: 'Thiết lập',
    subheaderI18n: 'MENU:setting',
  },
  {
    id: uniqueId(),
    title: 'Nhóm khách mời',
    titleI18n: 'MENU:group_invite',
    icon: IconTicket,
    href: '/group-invite',
  },
  {
    id: uniqueId(),
    title: 'Mã giảm giá',
    titleI18n: 'MENU:coupon',
    icon: IconDiscount2,
    href: '/coupon',
  },
  // {
  //   id: uniqueId(),
  //   title: 'Chương trình khuyến mãi',
  //   titleI18n: 'MENU:mst_promotion',
  //   icon: IconMarkdown,
  //   href: '/promotion',
  // },
  {
    id: uniqueId(),
    title: 'Mã PIN',
    titleI18n: 'MENU:pin',
    icon: IconKey,
    href: '/info-pin',
  },
  {
    id: uniqueId(),
    title: 'Giải thưởng',
    titleI18n: 'MENU:info-prizes',
    icon: IconTrophy,
    href: '/info-prizes',
  },
  {
    id: uniqueId(),
    title: 'Lịch trình',
    titleI18n: 'MENU:info_event',
    icon: IconCalendarClock,
    href: '/event-info',
  },
  {
    id: uniqueId(),
    title: 'Thông tin đăng ký',
    titleI18n: 'MENU:info_config_register',
    icon: IconToggleLeft,
    href: '/info-config-register',
  },
  // {
  //   id: uniqueId(),
  //   title: 'Thiết lập trò chơi',
  //   titleI18n: 'MENU:config_mst_game',
  //   icon: IconGoGame,
  //   href: '/mst-game',
  //   children: [
  //     {
  //       id: uniqueId(),
  //       title: 'Trò chơi',
  //       titleI18n: 'MENU:mst_game',
  //       icon: IconPoint,
  //       href: '/mst-game',
  //       isEqual: true,
  //     },
  //     {
  //       id: uniqueId(),
  //       title: 'Cấu hình người tổ chức',
  //       titleI18n: 'MENU:info_user_game',
  //       icon: IconPoint,
  //       href: '/info-user-game',
  //     },
  //   ],
  // },

  //Config mẫu in tem
  {
    id: uniqueId(),
    title: 'Vé in',
    titleI18n: 'MENU:mst_template_print',
    icon: IconPrinter,
    href: '/mst-template-print',
  },
  // {
  //   id: uniqueId(),
  //   title: 'Mẫu email',
  //   titleI18n: 'MENU:mst_template_email',
  //   icon: IconMail,
  //   href: '/mst-template-email',
  // },

  //Config tùy chỉnh gia diện
  // {
  //   id: uniqueId(),
  //   title: 'Tùy chỉnh giao diện',
  //   titleI18n: 'MENU:theme',
  //   icon: IconPalette,
  //   isLayout: true,
  //   href: '#',
  // },
];

(eventId === 43 || eventId === 5 || eventId === 6 || eventId === 25) &&
  Menuitems.push(
    {
      id: uniqueId(),
      title: 'Danh sách giao thương',
      titleI18n: 'MENU:trade',
      icon: IconHeartHandshake,
      href: '/trade',
    },
    {
      id: uniqueId(),
      title: 'Danh sách khách giao thương',
      titleI18n: 'MENU:business_connection_list',
      icon: IconHeartHandshake,
      href: '/guest-trade',
    },
  );

(eventId === 29 || eventId === 5 || eventId === 6) &&
  Menuitems.push({
    id: uniqueId(),
    title: 'Thiết lập trò chơi',
    titleI18n: 'MENU:config_mst_game',
    icon: IconGoGame,
    href: '/mst-game',
    children: [
      {
        id: uniqueId(),
        title: 'Trò chơi',
        titleI18n: 'MENU:mst_game',
        icon: IconPoint,
        href: '/mst-game',
        isEqual: true,
      },
      {
        id: uniqueId(),
        title: 'Cấu hình người tổ chức',
        titleI18n: 'MENU:info_user_game',
        icon: IconPoint,
        href: '/info-user-game',
      },
    ],
  });

export default Menuitems;
